import { create } from "zustand";

type StoredFilterValues = Record<string, string>;

interface FilterStoreState {
  values: Record<string, StoredFilterValues>;
  setValues: (filterKey: string, values: StoredFilterValues) => void;
  clear: (filterKey: string) => void;
}

export const useFilterStore = create<FilterStoreState>((set) => ({
  values: {},
  setValues: (filterKey, values) => set((state) => ({ values: { ...state.values, [filterKey]: values } })),
  clear: (filterKey) =>
    set((state) => {
      const next = { ...state.values };
      delete next[filterKey];
      return { values: next };
    }),
}));
